// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Article-module--cls1--3MUVH","cls2":"styles-Article-module--cls2--2HGqx styles-Article-module--cls1--3MUVH"};